module.exports = __webpack_public_path__ + "static/media/logo.7c094807.svg";